<app-management-sidemenu
  [(isOpen)]="isSideNavOpen"
  [managementType]="selectedManagementType"
  [actionType]="selectedActionType"
  (close)="isSideNavOpen = false"
  [selectedBusinessRule]="selectedBusinessRule"
  (refreshTable)="getBusinessRules()"
>
  <h1>{{ "businessRule" | localize }}</h1>
  <div
    class="business-rule-management-container  custom-admin-label-class"
    [ngClass]="{
      'sidenav-open': isSideNavOpen,
      'sidenav-close': !isSideNavOpen
    }"
  >
    <div class="business-rule-management-header">
      <div class="business-rule-management-process">
        <button
          class="add-new-business-rule"
          style="cursor: pointer"
          (click)="
            openSideNav(ManagementType.BusinessRuleManagement, ActionType.Create)
          "
        >
          <span> {{ "newBusinessRule" | localize }} </span>
          <img src="assets/icons/general/add-icon.png" alt="" />
        </button>
        <mat-slide-toggle labelPosition="before" color="primary" [checked]="_appsService.projectChecedkWorkRule" (change)="projectToggle($event)">{{'getProjectData' | localize}}</mat-slide-toggle>
      </div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <div class="table-responsive">
        <mat-table [dataSource]="dataSource">

          <!-- ruleKey Column -->
          <ng-container matColumnDef="ruleKey">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "ruleKey" | localize }}</mat-label>
                <input
                  #ruleKeyFilter
                  matInput
                  (keyup)="applyFilterBussinessRule($event ,dataSource,'ruleKey',1)" autocomplete="off"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.ruleKey }}"
              matTooltipPosition="below"
            >
              {{ element.ruleKey }}
            </mat-cell>
          </ng-container>

           <!-- ruleDescription Column -->
          <ng-container matColumnDef="ruleDescription">
            <mat-header-cell *matHeaderCellDef>
              <mat-form-field>
                <mat-label>{{ "ruleDescription" | localize }}</mat-label>
                <input
                  #ruleDescFilter
                  matInput
                  (keyup)="applyFilter($event ,dataSource,'ruleDescription',1)" autocomplete="off"
                />
              </mat-form-field>
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              matTooltip="{{ element.ruleDescription }}"
              matTooltipPosition="below"
            >
              {{ element.ruleDescription }}
            </mat-cell>
          </ng-container>

          <!-- options Column -->
          <ng-container matColumnDef="options">
            <mat-header-cell class="options-column" *matHeaderCellDef>
              #
            </mat-header-cell>
            <mat-cell class="options-cell" *matCellDef="let element">
              <button
                mat-icon-button
                [matMenuTriggerFor]="actionMenu"
                aria-label="Options"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu class="options-menu" #actionMenu="matMenu">
                <div class="menu-header">{{ "transactions" | localize }}</div>
                <button
                  mat-menu-item
                  (click)="
                    openSideNav(
                      ManagementType.BusinessRuleManagement,
                      ActionType.Update,
                      element
                    )
                  "
                >
                  <img
                    src="assets/icons/general/edit-project-icon.png"
                    alt=""
                  />
                  {{ "edit" | localize }}
                </button>

                <button mat-menu-item (click)="deleteBusinessRule(element)">
                  <img
                    src="assets/icons/general/delete-project-icon.png"
                    alt=""
                  />
                  {{ "businessRuleDelete" | localize }}
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>

          <!-- Define rows -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>

      <!--Paginator-->
      <div class="custom-paginator">
        <span *ngIf="(filteredBusinessRules?.length ?? businessRules.length) > 0; else noRecords">
          {{ (filteredBusinessRules?.length ?? businessRules.length) }} {{ 'entries' | localize }}
          {{ ((filteredBusinessRules?.length ?? businessRules.length) > 0) ? (currentPage * pageSize + 1) : 0 }} -
          {{ Math.min((filteredBusinessRules?.length ?? businessRules.length), (currentPage + 1) * pageSize) }}
          {{ 'betweenDisplayed' | localize }}
        </span>
        <ng-template #noRecords> {{ 'noRecordFound' | localize }} </ng-template>

        <!-- Paginator Buttons -->
        <button (click)="onPageChange(0)" [disabled]="currentPage === 0">
          &laquo;
        </button>
        <button
          (click)="onPageChange(currentPage - 1)"
          [disabled]="currentPage === 0"
        >
          &lt;
        </button>
        <ng-container *ngFor="let page of visiblePageNumbers">
          <button
            [class.active]="page - 1 === currentPage"
            (click)="onPageChange(page - 1)"
          >
            {{ page }}
          </button>
        </ng-container>
        <button
          (click)="onPageChange(currentPage + 1)"
          [disabled]="currentPage >= totalPages - 1"
        >
          &gt;
        </button>
        <button
          (click)="onPageChange(totalPages - 1)"
          [disabled]="currentPage >= totalPages - 1"
        >
          &raquo;
        </button>
        <!--PageSize selection-->
        <select [(ngModel)]="pageSize" (change)="updatePageSize($event)">
          <option *ngFor="let option of [5, 10]" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>
</app-management-sidemenu>
